import { toast } from "react-toastify";
import { ListMyPlan } from "../constants/myPlanConstants";

export const ListMyPlanAction = (payload) => (dispatch) => {
  dispatch({
    type: ListMyPlan.CREATE_PLAN_SUCCESS,
    payload,
  });
  toast.success('Plan Created', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    theme: 'dark'
    });
};
